import React from "react";

const SvgLargeWine = props => (
  <svg viewBox="0 0 215 215" {...props}>
    <path
      d="M136.7 36.8l-1.4-3.9H79.7l-1.4 3.9C74 48.5 71 60.7 69.2 73c-1.2 8.3-1.2 16.7 0 25 .9 6 3.2 11.7 6.6 16.7 5.7 8.2 16.5 12.9 28.2 14v51.9H80.8v7.5h54.7v-7.5h-23.8v-51.9c11.4-1.2 22-5.9 27.7-13.9 1.6-2.3 2.9-4.7 3.9-7.2 8.5-21.3-.1-52.7-6.6-70.8zM77.6 59.4c.4-1.9.8-3.9 1.4-5.7 1.6-6.1 3.4-11 4.7-14.9h47.5c1.3 3.7 3 9.1 4.6 14.9.9 2.8 1.6 5.7 1.6 5.7 1 4.3 2 9 2.6 13.7H75c.6-4.7 1.5-9.3 2.6-13.7z"
      fill="currentColor"
    />
  </svg>
);

export default SvgLargeWine;